import '../../../common/dashboard/filters/applied/applied_multiple_values_filter_view.js.coffee'
import '../hierarchical_tags_filter_mixin.js.coffee'

Namespace 'CustomerVisualMode.Filters.Applied'

class CustomerVisualMode.Filters.Applied.AppliedHierarchicalTagsFilterView extends
Common.Dashboard.Filters.AppliedMultipleValuesFilterView

  initialize: ({filter, tags, isReadOnly}) ->
    super({filter, isReadOnly})
    _.extend(@, CustomerVisualMode.Filters.HierarchicalTagsFilterMixin)
    @tags = tags

  _seeAll: ->
    @openHierarchicalTagsFilterModal()

  modalTitle: ->
    @filter.getName()

  removeValue: ({value}) ->
    @trigger('filter:value:remove', value: value)
